import type { SegmentedControlProps as MantineSegmentedControlProps } from '@mantine/core';
import { SegmentedControl as MantineSegmentedControl } from '@mantine/core';

import classes from './SegmentedControl.module.css';

export interface SegmentedControlProps extends MantineSegmentedControlProps {
  variant?: 'primary' | 'light' | 'subtle';
}

const SegmentedControlDefaults = MantineSegmentedControl.extend({
  classNames: {
    root: classes.root,
    indicator: classes.indicator,
    control: classes.control,
    label: classes.label,
  },
  defaultProps: {
    size: 'lg',
    radius: 'sm',
    variant: 'primary',
  },
});

const SegmentedControl = (props: SegmentedControlProps) => {
  return <MantineSegmentedControl {...props} />;
};

export { SegmentedControl, SegmentedControlDefaults };
